var _defs, _path, _path2, _path3, _rect, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #322920;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M579.47,283.72h79.18v120.89c0,21.85-17.74,39.59-39.59,39.59h0c-21.85,0-39.59-17.74-39.59-39.59v-120.89h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M457.25,283.72h79.18v120.89c0,21.85-17.74,39.59-39.59,39.59h0c-21.85,0-39.59-17.74-39.59-39.59v-120.89h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.03,283.72h79.18v120.89c0,21.85-17.74,39.59-39.59,39.59h0c-21.85,0-39.59-17.74-39.59-39.59v-120.89h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 241.74,
    y: 230.05,
    width: 516.52,
    height: 34.01
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M744.44,465.72c-32.53,0-59.13-25.57-60.94-57.66h-.35c-1.81,32.09-28.4,57.66-60.94,57.66s-59.13-25.57-60.94-57.66h-.35c-1.81,32.09-28.4,57.66-60.94,57.66s-59.13-25.57-60.94-57.66h-.35c-1.81,32.09-28.4,57.66-60.94,57.66s-59.13-25.57-60.94-57.66h-.35c-1.81,32.09-28.4,57.66-60.94,57.66-4.76,0-9.37-.6-13.81-1.63v305.86h516.52v-305.86c-4.45,1.03-9.06,1.63-13.82,1.63ZM464.16,638.16c0,1.91-1.55,3.45-3.45,3.45h-122.22c-1.91,0-3.45-1.55-3.45-3.45v-107.87c0-1.91,1.55-3.45,3.45-3.45h122.22c1.91,0,3.45,1.55,3.45,3.45v107.87ZM672.97,727.7c0,1.76-1.43,3.19-3.19,3.19h-117.17c-1.76,0-3.19-1.43-3.19-3.19v-197.68c0-1.76,1.43-3.19,3.19-3.19h117.17c1.76,0,3.19,1.43,3.19,3.19v197.68Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.74,283.72v158.99c3.4.95,6.96,1.49,10.66,1.49h0c21.86,0,39.59-17.72,39.59-39.59v-120.89h-50.25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M758.26,283.72h-56.56v120.89c0,21.86,17.72,39.59,39.59,39.59h0c6.08,0,11.82-1.41,16.97-3.86v-156.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIconSvg);
export default __webpack_public_path__ + "static/media/Shop Icon (SVG).094ade6d409775557e0897ac3d72f4b0.svg";
export { ForwardRef as ReactComponent };